module.exports = __webpack_public_path__ + "img/芦荟.53a94e47.jpg";